module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "part1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "PN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part I")])]), _vm._v(" "), _c('p', {
    staticClass: "PT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_part1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "SANS-BI"
  }, [_vm._v("Golden Triangle (1968–87)")])])]), _vm._v(" "), _c('p', {
    staticClass: "PEP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("When you’re good to Mama, Mama’s good to you.")])]), _vm._v(" "), _c('p', {
    staticClass: "PEPC"
  }, [_vm._v("—John Kander and Fred Ebb, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "PEP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The world wanders into many strange by-paths of affection. The love of a mother for her children is dominant, leonine, selfish, and unselfish.")])]), _vm._v(" "), _c('p', {
    staticClass: "PEPC"
  }, [_vm._v("—Theodore Dreiser")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ab456b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 78
// module chunks = 0